import { t } from 'i18next';

export const InvoiceCreatorItemGridPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: t('documents.invoice.gridPluginName'),
        mnemocode: "invoice_item_create_plugin",
        permission: "Invoice",
        columns: [
            {
                order: index++,
                propertyName: "alerts",
                propertyType: "string",
                displayName: t('documents.invoice.fields.alert'),
                visibility: true,
                width: 60,
            },
            {
                order: index++,
                propertyName: "lineStatus",
                propertyType: "string",
                displayName: t('documents.invoice.fields.lineStatus'),
                visibility: true,
                width: 60,
            },
            {
                order: index++,
                propertyName: "idGlobal",
                propertyType: "string",
                displayName: t('documents.invoice.fields.idGlobal'),
                visibility: false,
                width: 100,
            },
            {
                order: index++,
                propertyName: "idGoodsGlobal",
                propertyType: "string",
                displayName: t('documents.invoice.fields.idGoodsGlobal'),
                visibility: false,
                width: 100,
            },
            {
                order: index++,
                propertyName: "goodsName",
                propertyType: "string",
                displayName: t('documents.invoice.fields.goodsName'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "scalingRatioName",
                propertyType: "string",
                displayName: t('documents.invoice.fields.scalingRatioName'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "quantity",
                propertyType: "number",
                displayName: t('documents.invoice.fields.quantity'),
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "actualQuantity",
                propertyType: "number",
                displayName: t('documents.invoice.fields.actualQuantity'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "damageQuantity",
                propertyType: "number",
                displayName: t('documents.invoice.fields.damageQuantity'),
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "defectQuantity",
                propertyType: "number",
                displayName: t('documents.invoice.fields.defectQuantity'),
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "shortageQuantity",
                propertyType: "number",
                displayName: t('documents.invoice.fields.shortageQuantity'),
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "retailPriceIncVat",
                propertyType: "decimal",
                displayName: t('documents.invoice.fields.retailPriceIncVat'),
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "gtin",
                propertyType: "string",
                displayName: t('documents.invoice.fields.gtin'),
                visibility: true,
                width: 150,
                changeable: true,
            },
            {
                order: index++,
                propertyName: "retailAmount",
                propertyType: "number",
                displayName: t('documents.invoice.fields.retailAmount'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "retailAmountIncVat",
                propertyType: "number",
                displayName: t('documents.invoice.fields.retailAmountIncVat'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "retailVat",
                propertyType: "number",
                displayName: t('documents.invoice.fields.retailVat'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierAmount",
                propertyType: "number",
                displayName: t('documents.invoice.fields.supplierAmount'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierAmountIncVat",
                propertyType: "number",
                displayName: t('documents.invoice.fields.supplierAmountIncVat'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierPrice",
                propertyType: "number",
                displayName: t('documents.invoice.fields.supplierPrice'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierPriceIncVat",
                propertyType: "number",
                displayName: t('documents.invoice.fields.supplierPriceIncVat'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "supplierVat",
                propertyType: "number",
                displayName: t('documents.invoice.fields.supplierVat'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "producerPrice",
                propertyType: "number",
                displayName: t('documents.invoice.fields.producerPrice'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "productMargin",
                propertyType: "number",
                displayName: t('documents.invoice.fields.productMargin'),
                visibility: true,
                width: 150,
                changeable: true,
        },
            {
                order: index++,
                propertyName: "isKiz",
                propertyType: "boolean",
                displayName: t('documents.invoice.fields.isKiz'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "isGnvls",
                propertyType: "boolean",
                displayName: t('documents.invoice.fields.isGnvls'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "countKizScan",
                propertyType: "number",
                displayName: t('documents.invoice.fields.countKizScan'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "numerator",
                propertyType: "number",
                displayName: t('documents.invoice.fields.numerator'),
                visibility: false,
                width: 150,
            },
            {
                order: index++,
                propertyName: "denominator",
                propertyType: "number",
                displayName: t('documents.invoice.fields.denominator'),
                visibility: false,
                width: 150,
            },
            {
                order: index++,
                propertyName: "retailPrice",
                propertyType: "number",
                displayName: t('documents.invoice.fields.retailPrice'),
                visibility: true,
                width: 150,
            },
            {
                order: index++,
                propertyName: "idInvoiceItemGroupGlobal",
                propertyType: "string",
                displayName: t('documents.invoice.fields.idInvoiceItemGroupGlobal'),
                visibility: false,
                width: 200,
            },
            {
                order: index++,
                propertyName: "seriesNumber",
                propertyType: "string",
                displayName: t('documents.invoice.fields.seriesNumber'),
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "bestBefore",
                propertyType: "date",
                displayName: t('documents.invoice.fields.bestBefore'),
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "isOsu",
                propertyType: "boolean",
                displayName: t('documents.invoice.fields.isOsu'),
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "goodsCode",
                propertyType: "string",
                displayName: t('documents.invoice.fields.goodsCode'),
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "producer",
                propertyType: "string",
                displayName: t('documents.invoice.fields.producer'),
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "storePlaceName",
                propertyType: "string",
                displayName: t('documents.invoice.fields.storePlaceName'),
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                changeable: true,
                propertyName: "kizCategory",
                propertyType: "string",
                displayName: t('documents.invoice.fields.kizCategory'),
                visibility: true,
                width: 200,
            },
            {
                order: index++,
                propertyName: "financialSecurityCode",
                propertyType: "string",
                displayName:  t('documents.invoice.fields.financialSecurity'),
                visibility: false,
                width: 200,
            },
        ],
    }
};